import { get } from 'lodash'
import React, { useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { X, Check } from 'react-bootstrap-icons'
import useUserMutations from '../../../hooks/use-user-mutations'
import useToasts from '../../../hooks/use-toasts'

const EditStudentId = ({
    user = {},
    onClose = () => {},
}) => {
    const [ studentId, setStudentId ] = useState(get(user, 'studentId', ''))
    
    const { toastError } = useToasts({
        errorMessage: 'Error updating user.'
    })

    const { saveUser, isSaving } = useUserMutations({
        onSuccess: onClose,
        onError: toastError,
    })
    return (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ flexGrow: '0.9', color: 'black', display: 'flex' }}>
                <Form.Control placeholder="Student ID" value={studentId} onChange={e => setStudentId(e.target.value)} />
            </div>
            <div style={{ display: 'flex', alignItems: 'center'}}>
                <Button disabled={isSaving} variant='outline-secondary' onClick={() => onClose()} ><X /></Button>
                <Button disabled={isSaving} variant='primary' onClick={() => saveUser({ ...user, studentId })} ><Check /></Button>
            </div>
        </div>
    )
}

export default EditStudentId